import { Breadcrumb, Button, Col, Form, Input, Row, Select } from "antd";
import { useTranslation } from "react-i18next";
import { _adr } from "../../../address";
import { HomeOutlined } from "@ant-design/icons";
import { Content } from "antd/es/layout/layout";
import { convertPersian, validateInput } from "../../../tools/tools";
import DatePicker from "../../auxiliary/datepicker/datepicker";
import Iinput from "../../auxiliary/inputs/Input";
import ReactInputMask from "react-input-mask";

const CDEditProfile = () => {
	const [t] = useTranslation("global");
	const [frmProfile] = Form.useForm();
	const handleSubmit = (values) => {};
	const handleGetDate = () => {};
	return (
		<>
			<div className="container-main container-cw">
				<div className="holder-top-of-page-content">
					<div className="g-hold-title-of-page">
						<Breadcrumb
							className="breadcrumbs"
							items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("creditCard.title") }]}
						/>
						<div className="title-page">
							<h3>{t("creditCard.title")}</h3>
							<p></p>
						</div>
					</div>
				</div>
				<div className="g-layout-content">
					<Content className="g-layout-main da-container">
						<div className="g-format-page">
							<div className="g-body-format-page">
								<div className="page_title">اطلاعات هویتی </div>
								<br />
								<Form id="frmProfile" form={frmProfile} onFinish={handleSubmit} layout="vertical">
									<Row gutter={30}>
										<Col xs={24} sm={12} md={12} lg={10} xl={8}>
											<Form.Item name="fname" className="input-normal" rules={[validateInput({ t: t, validate: true })]} label="نام (فارسی)">
												<Input />
											</Form.Item>
										</Col>
										<Col xs={24} sm={12} md={12} lg={10} xl={8}>
											<Form.Item name="lname" className="input-normal" rules={[validateInput({ t: t, validate: true })]} label="نام خانوادگی (فارسی)">
												<Input />
											</Form.Item>
										</Col>
									</Row>
									<Row gutter={30}>
										<Col xs={24} sm={12} md={12} lg={10} xl={8}>
											<Form.Item name="enfname" className="input-normal" rules={[validateInput({ t: t, validate: true })]} label="نام  (انگلیسی)">
												<Iinput />
											</Form.Item>
										</Col>
										<Col xs={24} sm={12} md={12} lg={10} xl={8}>
											<Form.Item
												name="enlname"
												className="input-normal"
												rules={[validateInput({ t: t, validate: true })]}
												label="نام خانوادگی (انگلیسی)">
												<Iinput />
											</Form.Item>
										</Col>
									</Row>
									<Row gutter={30}>
										<Col xs={24} sm={12} md={12} lg={10} xl={8}>
											<Form.Item
												className="input-normal"
												name="birthdate"
												rules={[validateInput({ t: t, validate: true })]}
												label="تاریخ تولد (شمسی)">
												<DatePicker values={frmProfile.getFieldValue("birthdate")} onChange={handleGetDate} lang={true} />
											</Form.Item>
										</Col>
										<Col xs={24} sm={12} md={12} lg={10} xl={8}>
											<Form.Item
												className="input-normal"
												name="birthdate"
												rules={[validateInput({ t: t, validate: true })]}
												label="تاریخ تولد (میلادی)">
												<DatePicker values={frmProfile.getFieldValue("enbirthdate")} onChange={handleGetDate} lang={false} />
											</Form.Item>
										</Col>
									</Row>
									<Row gutter={30}>
										<Col xs={24} sm={12} md={12} lg={10} xl={8}>
											<Form.Item
												className="input-normal"
												name="certno"
												label="کدملی"
												rules={[
													validateInput({
														t: t,
														validate: true,
														length: 10,
													}),
												]}>
												<Iinput maxLength={10} inputMode="numeric" dir="ltr" placeholder="کدملی خود را وارد کنید" />
											</Form.Item>
										</Col>
										<Col xs={24} sm={12} md={12} lg={10} xl={8}>
											<Form.Item
												className="input-normal"
												name="certno"
												label="شماره پاسپورت"
												rules={[
													validateInput({
														t: t,
														validate: true,
														length: 10,
													}),
												]}>
												<Iinput maxLength={10} inputMode="numeric" dir="ltr" placeholder="" />
											</Form.Item>
										</Col>
									</Row>
									<Row gutter={30}>
										<Col xs={24} sm={12} md={12} lg={10} xl={8}>
											<Form.Item
												className="input-normal"
												name="fathername"
												label="نام پدر"
												rules={[
													validateInput({
														t: t,
														validate: true,
														type: "persian",
													}),
												]}>
												<Iinput />
											</Form.Item>
										</Col>
										<Col xs={24} sm={12} md={12} lg={10} xl={8}>
											<Form.Item className="input-normal" name="gender" label="جنسیت" rules={[validateInput({ t: t, validate: true })]}>
												<Select>
													{/* {initialData?.gender.map((item, key) => (
															<Select.Option key={key} value={item.value}>
																{item.name}
															</Select.Option>
														))} */}
												</Select>
											</Form.Item>
										</Col>
									</Row>
									<Row gutter={30}>
										<Col xs={24} sm={12} md={12} lg={10} xl={8}>
											<Form.Item
												className="input-normal"
												name="identityno"
												label="شماره شناسنامه"
												rules={[
													validateInput({
														t: t,
														validate: true,
														type: "number",
													}),
												]}>
												<Iinput dir="ltr" inputMode="numeric" />
											</Form.Item>
										</Col>
										<Col xs={24} sm={12} md={12} lg={10} xl={8}>
											<Form.Item
												className="input-normal"
												name="smsmobileno"
												label={"شماره همراه"}
												rules={[
													validateInput({
														t: t,
														validate: true,
														type: "msisdnOrg",
													}),
												]}>
												<div>
													<ReactInputMask
														mask="0\999 99 99 999"
														id="refMsisdn"
														// value={frmProfile.getFieldValue("smsmobileno")?.length > 0 ? frmProfile.getFieldValue("smsmobileno") : ""}
														onChange={(e) => {
															e.target.value = convertPersian(e.target.value);
															// setValMsisdn(e.target.value);
														}}
														className="msisdn-mask"
														dir="ltr"
													/>
												</div>
											</Form.Item>
										</Col>
									</Row>
								</Form>
							</div>
							<div className="g-footer-format-page">
								<div className="holder-button">
									<Button
										// disabled={10 - prof.counterSim > 0 ? false : true}
										form="frmProfile"
										key="submit"
										htmlType="submit"
										className="btn-normal btn-green">
										ویرایش
									</Button>
								</div>
							</div>
						</div>
					</Content>
				</div>
			</div>
		</>
	);
};

export default CDEditProfile;
